import React from 'react';
import { Placeholder } from '@components/common/Placeholder';

export const Unauthorized: React.FC = () => {
  return (
    <Placeholder 
      title="403 - Unauthorized" 
      description="You do not have permission to access this resource."
    />
  );
};